/*!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
* GRL_MODIFY: Modified from codegen version. GRL_MODIFY marks changes
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!*/
/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { RiskManagementProcessesRecords } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function RiskManagementProcessesRecordsCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    presets, // GRL_MODIFY: add presets prop
    ...rest
  } = props;
  const initialValues = {
    DataSetName: "",
    Description: "",
    ToolsMethods: "",
    RelativePrioritisationProcess: "",
    ...presets // GRL_MODIFY: add presets to initial values
  };
  const [DataSetName, setDataSetName] = React.useState(
    initialValues.DataSetName
  );
  const [Description, setDescription] = React.useState(
    initialValues.Description
  );
  const [ToolsMethods, setToolsMethods] = React.useState(
    initialValues.ToolsMethods
  );
  const [RelativePrioritisationProcess, setRelativePrioritisationProcess] =
    React.useState(initialValues.RelativePrioritisationProcess);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setDataSetName(initialValues.DataSetName);
    setDescription(initialValues.Description);
    setToolsMethods(initialValues.ToolsMethods);
    setRelativePrioritisationProcess(
      initialValues.RelativePrioritisationProcess
    );
    setErrors({});
  };
  const validations = {
    DataSetName: [],
    Description: [],
    ToolsMethods: [],
    RelativePrioritisationProcess: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          DataSetName,
          Description,
          ToolsMethods,
          RelativePrioritisationProcess,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(new RiskManagementProcessesRecords(modelFields));
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(
        overrides,
        "RiskManagementProcessesRecordsCreateForm"
      )}
      {...rest}
    >
      <Heading
        level={4}
        children="Risk Management"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="NZCS1 Paragraphs 17-19."
        {...getOverrideProps(overrides, "SectionalElement00")}
      ></Heading>
      <Text
        children="Create a record that collates how climate-related risks are identified, assessed, and managed and how those processes are integrated into existing risk management processes."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <TextField
        label="Risk management record name (e.g. 2025 risk management records)"
        isRequired={false}
        isReadOnly={false}
        value={DataSetName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName: value,
              Description,
              ToolsMethods,
              RelativePrioritisationProcess,
            };
            const result = onChange(modelFields);
            value = result?.DataSetName ?? value;
          }
          if (errors.DataSetName?.hasError) {
            runValidationTasks("DataSetName", value);
          }
          setDataSetName(value);
        }}
        onBlur={() => runValidationTasks("DataSetName", DataSetName)}
        errorMessage={errors.DataSetName?.errorMessage}
        hasError={errors.DataSetName?.hasError}
        {...getOverrideProps(overrides, "DataSetName")}
      ></TextField>
      <TextAreaField
        label="Description (e.g. Risk management records for 2025)"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName,
              Description: value,
              ToolsMethods,
              RelativePrioritisationProcess,
            };
            const result = onChange(modelFields);
            value = result?.Description ?? value;
          }
          if (errors.Description?.hasError) {
            runValidationTasks("Description", value);
          }
          setDescription(value);
        }}
        onBlur={() => runValidationTasks("Description", Description)}
        errorMessage={errors.Description?.errorMessage}
        hasError={errors.Description?.hasError}
        	value={Description} // GRL_MODIFY: correct value prop
        {...getOverrideProps(overrides, "Description")}
      ></TextAreaField>
      <Heading
        children="NZCS1 paragraph 19a."
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Heading>
      <TextAreaField
        label="Describe the tools and methods used to identify, and to assess the scope, size, and impact of, your identified climate-related risks"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName,
              Description,
              ToolsMethods: value,
              RelativePrioritisationProcess,
            };
            const result = onChange(modelFields);
            value = result?.ToolsMethods ?? value;
          }
          if (errors.ToolsMethods?.hasError) {
            runValidationTasks("ToolsMethods", value);
          }
          setToolsMethods(value);
        }}
        onBlur={() => runValidationTasks("ToolsMethods", ToolsMethods)}
        errorMessage={errors.ToolsMethods?.errorMessage}
        hasError={errors.ToolsMethods?.hasError}
        	value={ToolsMethods} // GRL_MODIFY: correct value prop
        {...getOverrideProps(overrides, "ToolsMethods")}
      ></TextAreaField>
      <Heading
        children="NZCS1 paragraph 19e."
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Heading>
      <TextAreaField
        label="Describe your processes for prioritising climate-related risks relative to other types of risks"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName,
              Description,
              ToolsMethods,
              RelativePrioritisationProcess: value,
            };
            const result = onChange(modelFields);
            value = result?.RelativePrioritisationProcess ?? value;
          }
          if (errors.RelativePrioritisationProcess?.hasError) {
            runValidationTasks("RelativePrioritisationProcess", value);
          }
          setRelativePrioritisationProcess(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "RelativePrioritisationProcess",
            RelativePrioritisationProcess
          )
        }
        errorMessage={errors.RelativePrioritisationProcess?.errorMessage}
        hasError={errors.RelativePrioritisationProcess?.hasError}
        	value={RelativePrioritisationProcess} // GRL_MODIFY: correct value prop
        {...getOverrideProps(overrides, "RelativePrioritisationProcess")}
      ></TextAreaField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
